import React, { FC } from 'react'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '@utils/authConfig'

const LayoutWithProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
	return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}

export default LayoutWithProvider